import { ApiService } from "services/api";
import MockApiService from "services/mock-api/MockApiService";
import { IApiService } from "services/models/ApiService";
import React, { ReactNode, useCallback, useContext, useMemo } from "react";
import { useAccessToken } from "./useAccessToken";
import { useMsalAccessToken } from "@sanmanuel/microsoft-auth";
import { loginRequest } from "authConfig";
import { ApiError } from "services/api/misc";

export interface ApiConfig {
  mock: boolean;
  accessToken: () => Promise<string>;
}

export const ApiContext = React.createContext<ApiConfig>({
  mock: true,
  accessToken: () => Promise.reject("Not Implemented"),
});

export function useApi(): IApiService {
  const { mock, accessToken } = useContext(ApiContext);
  return useMemo<IApiService>(() => (mock ? new MockApiService() : new ApiService(accessToken)), [accessToken, mock]);
}

type Props = {
  mock: boolean;
  children: ReactNode | ReactNode[];
};

export const ApiProvider = ({ mock, children }: Props) => {
  const { getAccessToken } = useMsalAccessToken(loginRequest);

  const requiredAccessToken = useCallback(
    () =>
      getAccessToken().then((t) => {
        if (!t) throw new ApiError(-2, "Failed to login");
        return t;
      }),
    [getAccessToken]
  );

  return <ApiContext.Provider value={{ mock, accessToken: requiredAccessToken }}>{children}</ApiContext.Provider>;
};
